import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bf464808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container content-container" }
const _hoisted_3 = {
  key: 1,
  class: "header__title subtitle"
}
const _hoisted_4 = {
  key: 2,
  class: "header__right-block"
}

import { useUserStore } from '@/stores/user';
import { IonIcon, useIonRouter } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { RouteLocationRaw, useRouter } from 'vue-router';

import UserAvatar from '@/components/UserAvatar.vue';

interface HeaderProps {
  title?: string | null;
  showBackButton?: boolean;
  showAvatar?: boolean;
  isLoading?: false | boolean;
  backgroundColor?: '#fff' | string;
  to?: RouteLocationRaw | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  props: {
    title: {},
    showBackButton: { type: Boolean, default: true },
    showAvatar: { type: Boolean, default: true },
    isLoading: { type: Boolean },
    backgroundColor: {},
    to: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const ionRouter = useIonRouter();
const userStore = useUserStore();

function handleBackClick() {
  if (props.to) {
    ionRouter.navigate(props.to, 'back', 'push');
    return;
  }
  if (
    !router.options.history.state.back ||
    (router.options.history.state.back === '/auth' && userStore.isLogged)
  ) {
    return router.push({ name: 'Feed' });
  }
  return router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.showBackButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "header__back-button",
            onClick: handleBackClick
          }, [
            _createVNode(_unref(IonIcon), { icon: _unref(chevronBackOutline) }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (props.showAvatar || _ctx.$slots.rightBlock)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "rightBlock"),
            (props.showAvatar)
              ? (_openBlock(), _createBlock(UserAvatar, {
                  key: 0,
                  user: _unref(userStore).user,
                  clickable: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'MyProfile' })))
                }, null, 8, ["user"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})